import { render } from "./BoB.vue?vue&type=template&id=790d596a"
import script from "./BoB.vue?vue&type=script&lang=js"
export * from "./BoB.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__